import React, { forwardRef, PropsWithChildren } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import { SxProps, Theme } from "@mui/system";
import { EnumTagColor } from "src/types/common-enum";

type TTagColors = "green" | "gray" | "blush" | "lilac" | "blue" | "orange" | "teal";

export const colorStyles: Record<TTagColors, SxProps<Theme>> = {
    blush: {
        color: "blush.700",
        "&:hover": { bgcolor: "blush.50" },
        "&:active": { bgcolor: "blush.200" },
        "&.Mui-disabled": { color: "blush.300" },
    },
    lilac: {
        color: "lilac.600",
        "&:hover": { bgcolor: "lilac.50" },
        "&:active": { bgcolor: "lilac.200" },
        "&.Mui-disabled": { color: "lilac.300" },
    },
    blue: {
        color: "blue.600",
        "&:hover": { bgcolor: "blue.50" },
        "&:active": { bgcolor: "blue.200" },
        "&.Mui-disabled": { color: "blue.300" },
    },
    orange: {
        color: "orange.600",
        "&:hover": { bgcolor: "orange.50" },
        "&:active": { bgcolor: "orange.200" },
        "&.Mui-disabled": { color: "orange.300" },
    },
    teal: {
        color: "teal.700",
        "&:hover": { bgcolor: "teal.100" },
        "&:active": { bgcolor: "teal.200" },
        "&.Mui-disabled": { color: "teal.300" },
    },
    gray: {
        color: "gray.800",
        "&:hover": { bgcolor: "gray.50" },
        "&:active": { bgcolor: "gray.100" },
        "&.Mui-disabled": { color: "gray.300" },
    },
    green: {
        color: "green.600",
        "&:hover": { bgcolor: "green.100" },
        "&:active": { bgcolor: "green.200" },
        "&.Mui-disabled": { color: "green.300" },
    },
};

export interface ITagButtonProps extends PropsWithChildren<Omit<ButtonProps, "color">> {
    color?: `${EnumTagColor}`;
}

export const TagButton = forwardRef<HTMLButtonElement, ITagButtonProps>(function TagButton({ color = "gray", children, sx, ...props }, ref) {
    const mergedSx = [
        {
            borderRadius: 2,
            bgcolor: "transparent",
            "&:focus": { bgcolor: "transparent" },
            "&.Mui-disabled": { bgcolor: "transparent" },
            ...colorStyles[color],
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ];
    return (
        <Button ref={ref} variant="outlined" size="extraSmall" sx={mergedSx} {...props}>
            {children}
        </Button>
    );
});
